export const moduleConfig = {
    entityKey: 'meter-assignments',
    titles: {
        singular: 'Meter Assignment',
        plural: 'Meter Assignments'
    }
}

export const initialSortState = {
    column: 'created',
    direction: 'desc',
};
